import { Link } from "react-router-dom";
import { getLinks, groupFormEnabled, hasAnyLink } from "@/lib/content";
import { t } from "@/lib/i18n";
import Reveal from "@/components/Reveal";
import ContactLinks from "@/components/ContactLinks";
import { path } from "@/lib/routes";

export default function ContactCta({ content, isPreview }) {
  const links = getLinks(content, isPreview);
  if (!hasAnyLink(links) && !groupFormEnabled(content)) return null;
  return (
    <section className="bg-forest text-cream" data-testid="home-contact-cta">
      <div className="safe-x max-w-7xl mx-auto py-20 sm:py-28 grid gap-12 lg:grid-cols-2 lg:gap-20 items-center">
        <Reveal>
          <p className="eyebrow !text-gold-light mb-4">{t("home.ctaEyebrow")}</p>
          <h2 className="text-4xl sm:text-5xl font-semibold leading-[1.08]">{t("home.ctaTitle")}</h2>
          <p className="mt-6 text-lg text-cream/85 max-w-lg">{t("home.ctaText")}</p>
          <Link to={path("iletisim")} className="mt-10 inline-flex items-center justify-center min-h-[52px] px-7 rounded-full bg-gold-light text-forest-dark font-semibold hover:bg-[#F0D8A6] transition-colors" data-testid="home-cta-contact-button">
            {t("home.ctaButton")}
          </Link>
        </Reveal>
        <Reveal delay={120}>
          <ContactLinks links={links} isPreview={isPreview} dark />
        </Reveal>
      </div>
    </section>
  );
}
